<ion-list>
    <div *ngFor="let complex of eventsComplex; index as i; first as isFirst">
        <ion-item-divider class="list-header" color="light">
            <img class="list-header-img" src='../../../assets/imgs/sport_types/{{ eventType }}.png'>
            <div class="primary">{{ complex.category }}</div>
        </ion-item-divider>
        <!-- <ion-item class="list-item button-flex" *ngFor="let event of arrayOf(complex.event, i)"
            (click)="openEventDetails(event)">
            <h4 class="event-date">{{ event.dateFormatted }}</h4>
            <div class="event-name">
                <h4 class="padding-left" text-nowrap>{{ event.eventName }}</h4>
            </div>
            <div class="event-status">
                <h6 style="color:red"><em>{{ getEventStatus(event) }}</em></h6>
            </div>
        </ion-item> -->

        <ion-item class="list-item button-flex" *ngFor="let event of arrayOf(complex.event, i)"
            (click)="onEventLoad(event)">
            <ion-avatar item-start>
                <img src="{{event.imgPath}}">
            </ion-avatar>
            <ion-row *ngIf="type === 'Events'" class="flex-space-between">
                <h4 class="event-date">{{ event.dateFormatted }}</h4>
                <h4 class="event-date" *ngIf="event?.eventType.includes('V')">{{ event.distance }}</h4>
                <h4 class="event-date" *ngIf="event.eventStatus.includes('C')" style="margin-left: -80px;">
                    {{ event.distance }}</h4>
                <h4 style="color:red" *ngIf="event.eventStatus.includes('C')">{{ getEventStatus(event) }}</h4>
            </ion-row>

            <ion-row *ngIf="type === 'Events'">
                <h4 text-nowrap>{{ event.eventName }}</h4>
            </ion-row>

            <ion-row *ngIf="type !== 'Events'">
                <h4 class="event-date">{{ event.dateFormatted }}</h4>
                <h4 class="padding-left" style="max-width: 75%;" text-nowrap>
                    {{ event.eventName }}</h4>
            </ion-row>

        </ion-item>

        <ion-item style="text-align: center;">
            <button ion-button (click)="onMorePress(i)" *ngIf="type === 'Events'">
                {{ 'GLOBAL_MORE_EVENTS' | translate | uppercase }}</button>
            <button ion-button (click)="onMorePress(i)" *ngIf="type !== 'Events'">
                {{ 'GLOBAL_MORE_RESULTS' | translate | uppercase }}</button>
        </ion-item>
    </div>
</ion-list>